import { mapping } from '../app-routing/products.uuids';

export const MODULE_ROOT = mapping['stammdaten'].url;
